import { createContext, useContext } from 'react';
import {
  AppLaunchNotificationContextValue,
  NotificationStatus,
} from 'src/context/AppLaunchNotificationsProvider/AppLaunchNotificationsProvider.types';

export const initialLaunchNotificationsStatus: NotificationStatus = {
  storeClosedOpen: false,
  outOfCoverageOpen: false,
};

export const AppLaunchNotificationsContext =
  createContext<AppLaunchNotificationContextValue>({
    storeClosedOpen: false,
    outOfCoverageOpen: false,
  });

export function useAppLaunchNotificationsContext() {
  const context = useContext(AppLaunchNotificationsContext);

  if (context === undefined) {
    throw new Error(
      'useAppLaunchNotificationsContext must be used within an AppLaunchNotificationsProvider'
    );
  }
  return context;
}
